import type { IOutcomeConsensus } from "~/types/event";
import { LOW_CONFIDENCE_NOTE } from "~/utils/getConsensusDisplay";
import { getWithheldMarketCount } from "~/utils/getWithheldMarketCount";
import { chanceColumn } from "~/utils/marketValue";

const NOT_AVAILABLE = "PH Consensus is not available for this outcome yet.";

const excludedNote = (count: number): string => {
  if (!count) {
    return "";
  }

  return count === 1
    ? " 1 market is left out because its bid/ask gap is wider than 10¢, which means an empty order book rather than a price."
    : ` ${count} markets are left out because their bid/ask gap is wider than 10¢, which means an empty order book rather than a price.`;
};

export const getChanceBreakdown = (
  outcome: IOutcomeConsensus | null
): string => {
  if (!outcome) {
    return NOT_AVAILABLE;
  }

  const { chance, lowConfidence, excluded } = outcome;
  const lead = lowConfidence ? `${LOW_CONFIDENCE_NOTE}\n\n` : "";
  const leftOut = lowConfidence
    ? ""
    : excludedNote(getWithheldMarketCount(excluded));

  return `${lead}PH Consensus: ${chanceColumn.format(chance)}
The implied Yes probability across platforms, weighted by each market's trading volume, so a market that has barely traded cannot skew it.${leftOut}

Simple average: ${chanceColumn.format(outcome.averageChance)}
Every traded market counts equally, however little it has traded. Shown for comparison.

Liquidity-weighted: ${chanceColumn.format(outcome.liquidityWeightedChance)}
Weighted by order-book liquidity. Not every platform reports liquidity, so this can lean on a single platform.`;
};
